import i18n from '@/locales/i18n'
import { PRODUCTS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'
import ProductsListView from '../../views/ProductsView/ProductsListView.vue'
import ProductDetailView from '../../views/ProductsView/ProductDetailView.vue'

export const PRODUCTS_LIST_ROUTE_NAME = 'productsList'
export const PRODUCTS_DETAIL_ROUTE_NAME = 'productsDetail'

const routes: RouteType[] = [
    {
        path: PRODUCTS_ROUTES.baseUrl,
        name: PRODUCTS_LIST_ROUTE_NAME,
        component: ProductsListView,
        meta: {
            title: i18n.global.t('menu.products'),
            authRequired: true
        }
    },
    {
        path: PRODUCTS_ROUTES.detailUrl,
        name: PRODUCTS_DETAIL_ROUTE_NAME,
        component: ProductDetailView,
        meta: {
            title: i18n.global.t('menu.products'),
            authRequired: true
        }
    }
]

export default routes
